import { getClemanClientByClient } from "@/apis"
import { Tenant, graphqlUrl as tenantGraphqlUrl } from '@/apis/tenant/tenant'
import { createContext, useEffect, useState } from 'react'
import { CLEWORD_DEFAULT_TITLE } from '@/constant'
import React from "react"
import { useMount } from "ahooks"
import { toast } from "react-hot-toast"

const handleGetTenantByClient = async (namespace: string) => {
  if (namespace) {
    try {
      const client = getClemanClientByClient()
      const tenant = await client.apollo.query<{ tenant: Tenant }>({
        query: tenantGraphqlUrl,
        variables: {
          namespace
        },
        fetchPolicy: 'no-cache'
      })
      console.log('>>>tenant', tenant)
      if (tenant.data.tenant) {
        return tenant.data.tenant
      }
    } catch (error) {
      console.log('获取租户信息出错', error)
      toast.error(`获取租户信息错误，${error.message}`)
    }
  } else {
    return {
      id: '',
      name: CLEWORD_DEFAULT_TITLE,
      namespace: '',
      logo: 'https://res.pandateacher.com/K9CBKKNV1636358161242.png',
      authingIdps: []
    }
  }
}

export const AuthingConfigContext = createContext<{
  AUTHING_APP_HOST: string
  AUTHING_APP_ID: string
}>(null)

export const AuthingWrapper = ({ children, __SERVER_VAR__, namespace }) => {
  const [tenant, setTenant] = useState(null)

  useMount(async () => {
    const tenant = await handleGetTenantByClient(namespace)
    setTenant(tenant)
  })

  return <AuthingConfigContext.Provider value={__SERVER_VAR__}>
    {children(tenant)}
  </AuthingConfigContext.Provider>
}